var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGracias(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: white;\n        stroke: #fff;\n        stroke-miterlimit: 16;\n        stroke-width: 1px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31,1.8c-6.9,0-9,5.2-9,5.2,0,0-2.2-5.2-9-5.2C2.1,1.8-3.4,14.1,8.3,25.4c10.6,10.3,13.8,16.9,13.8,16.9,0,0,3.1-6.6,13.8-16.9C47.5,14.1,42,1.9,31,1.8Z"
  }))), /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "http://ns.adobe.com/SaveForWeb/1.0/"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    x: 0.26,
    y: 0.22,
    width: 43.6,
    height: 45.48,
    bottomLeftOrigin: "true"
  }), /*#__PURE__*/React.createElement("optimizationSettings", null, /*#__PURE__*/React.createElement("targetSettings", {
    fileFormat: "PNG24Format",
    targetSettingsID: 0
  }, /*#__PURE__*/React.createElement(PNG24Format, {
    filtered: "false",
    interlaced: "false",
    matteColor: "#FFFFFF",
    noMatteColor: "false",
    transparency: "true"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGracias);
export default __webpack_public_path__ + "static/media/Gracias.8819be6a15d7de67636360d67db8c6e9.svg";
export { ForwardRef as ReactComponent };